const { SET_GALLERY_CONTENT } = require('constants/actionTypes/gallery');

const initialState = {};

const reducer = function (state = initialState, action) {
    const { type, payload } = action;

    switch (type) {
        case SET_GALLERY_CONTENT: {
            return payload;
        }
        default: {
            return state;
        }
    }
};

module.exports = reducer;
